import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { VouchersRoutingModule } from './vouchers-routing.module';
import { VouchersListComponent } from './vouchers-list/vouchers-list.component';
import {SharedModule} from "@shared/shared.module";
import {FormsModule} from "@angular/forms";
import {PopoverModule} from "ngx-bootstrap/popover";
import {NgxSpinnerModule} from "ngx-spinner";
import { CreateVoucherComponent } from './create-voucher/create-voucher.component';


@NgModule({
  declarations: [
    VouchersListComponent,
    CreateVoucherComponent
  ],
  imports: [
    CommonModule,
    VouchersRoutingModule,
    SharedModule,
    FormsModule,
    PopoverModule,
    NgxSpinnerModule
  ]
})
export class VouchersModule { }
